/**
 * Movimiento ligado al scroll y al puntero.
 *
 * Un único bucle de rAF para todo. Los listeners de scroll y pointermove solo
 * guardan el último valor y piden un frame; el trabajo de verdad ocurre una
 * vez por frame, sincronizado con el repintado del navegador. Así no importa
 * cuántos eventos dispare el sistema: nunca se hace más de un cálculo por
 * frame ni se lee el layout dentro del handler.
 *
 * Se apaga entero con prefers-reduced-motion.
 */

/** Cuánto se desplazan los halos respecto del scroll (0 = nada, 1 = igual). */
const PARALLAX_DEPTH = 0.12;
/** Desplazamiento máximo, en px, de los halos del hero al mover el mouse. */
const POINTER_RANGE = 26;

export function init() {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const header = document.querySelector('[data-header]');
  const parallaxEls = Array.from(document.querySelectorAll('[data-parallax]'));
  const hero = document.querySelector('.hero');

  if (!header && !parallaxEls.length) return;

  let scrollY = window.scrollY;
  let pointerX = 0;
  let pointerY = 0;
  let queued = false;

  /* Se recalcula al redimensionar, no en cada frame: leerlo en el bucle
     forzaría al navegador a rehacer el layout constantemente. */
  let maxScroll = 1;
  const measure = () => {
    maxScroll = Math.max(1, document.documentElement.scrollHeight - window.innerHeight);
  };
  measure();

  const render = () => {
    queued = false;

    if (header) {
      const progress = Math.min(1, Math.max(0, scrollY / maxScroll));
      header.style.setProperty('--scroll-progress', progress.toFixed(4));
    }

    for (const el of parallaxEls) {
      const depth = parseFloat(el.dataset.parallax) || PARALLAX_DEPTH;
      const y = -scrollY * depth;
      const px = pointerX * POINTER_RANGE * depth * 6;
      const py = pointerY * POINTER_RANGE * depth * 6;
      el.style.translate = `${px.toFixed(1)}px ${(y + py).toFixed(1)}px`;
    }
  };

  const schedule = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(render);
  };

  window.addEventListener('scroll', () => {
    scrollY = window.scrollY;
    schedule();
  }, { passive: true });

  window.addEventListener('resize', () => {
    measure();
    schedule();
  }, { passive: true });

  /* El seguimiento del puntero solo tiene sentido con mouse: en touch no hay
     puntero que seguir y el gesto es otro. */
  if (hero && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
    window.addEventListener('pointermove', (e) => {
      // Normalizado a -0.5 … 0.5 respecto del centro de la ventana.
      pointerX = e.clientX / window.innerWidth - 0.5;
      pointerY = e.clientY / window.innerHeight - 0.5;
      schedule();
    }, { passive: true });
  }

  schedule();
}
